export default "__VITE_ASSET__2UsLVDjE__"